import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CompanyInformation,
  CreateOrUpdateCompanyInformationRequest,
  HttpResponse,
} from "@/types";

export function useCreateCompanyInformation() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      createCompanyInformationRequest,
    }: {
      createCompanyInformationRequest: CreateOrUpdateCompanyInformationRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-informations`;
      const res = await guacHttpClient.post<
        CompanyInformation,
        HttpResponse<CompanyInformation>,
        CreateOrUpdateCompanyInformationRequest
      >(path, createCompanyInformationRequest);

      return res.data;
    },
  });

  return mutation;
}
